<template>
  <b-collapse :id="id">
    <b-card>
      <b-container>
        <b-form-row align-h="end">
          <b-col class="mb-1" cols="12" md="6">
            <b-form-input
              v-model="tmpSearch.text"
              type="search"
              @change="changeSearch()"
              :placeholder="textPlaceholder">
            </b-form-input>
          </b-col>

          <b-col class="mb-1" cols="12" v-for="(key, index) in Object.keys(tmpSearch.select)" :key="index">
            <b-form-group v-if="selectList[key]"
              :label="selectList[key].name + ':'"
              label-class="font-weight-bold text-right"
              label-cols="4"
            >
              <b-form-select
                v-model="tmpSearch.select[key]"
                :options="selectList[key].list"
                @change="changeSearch()"
                size="sm"
                :multiple="isMultiple(key)"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-row v-if="dateList.length" class="align-items-right" align-h="end">
          <template v-for="(span, index) in dateList">
            <b-col cols="12" lg="6" class="mb-2" :key="index">
              <div class="d-inline"><strong>{{span.name}}：</strong></div>
              <div class="d-inline">
                {{spanDate(tmpSearch.date[span.key].after)}}
                <b-form-datepicker size="sm" :id="span.key + '-after'"
                  v-model="tmpSearch.date[span.key].after"
                  today-button
                  reset-button
                  close-button
                  locale="ja"
                  :button-variant="buttonVariant(span.key)"
                  label-today-button="今日を指定"
                  label-reset-button="指定しない"
                  label-close-button="閉じる"
                  label-no-date-selected="条件なし"
                  button-only
                  :value-as-date="true"
                  @input="changeSearchDate(span.key)"
                  >
                </b-form-datepicker>
              </div>
              <div class="d-sm-inline align-items-left">
                <span>〜{{spanDate(tmpSearch.date[span.key].before)}}</span>
                <b-form-datepicker size="sm" :id="span.key + '-before'" v-model="tmpSearch.date[span.key].before"
                  today-button
                  reset-button
                  close-button
                  button-only
                  locale="ja"
                  :button-variant="buttonVariant(span.key)"
                  label-today-button="今日を指定"
                  label-reset-button="指定しない"
                  label-close-button="閉じる"
                  label-no-date-selected="条件なし"
                  :value-as-date="true"
                  @input="changeSearchDate(span.key)"
                  >
                </b-form-datepicker>
              </div>
              <div v-if="!isDateValid(span.key)" class="text-danger">日付の範囲が不正です。</div>
            </b-col>
          </template>
        </b-row>
        <b-row>
          <b-col><b-button size="sm" @click="resetSearch">条件リセット</b-button></b-col>
        </b-row>
      </b-container>
    </b-card>
  </b-collapse>
</template>

<script>
import ElementDatePicker from '@/components/presentationals/ElementDatePicker.vue'
import { dateButtonVariant, isDatespanValid, getArrangedDate } from '@/transformer/datespan.js'
export default {
  name: 'SearchForm',
  props: {
    fields: Array,
    search: Object,
    textPlaceholder: {
      type: String,
      default: '検索ワード'
    },
    id: {
      type: String,
      default: 'searchform'
    }
  },
  component: {
    ElementDatePicker
  },
  computed: {
    dateList: function () {
      if (!this.tmpSearch.date) {
        return []
      }
      return Object.keys(this.tmpSearch.date).map(e => {
        const fieldinfo = this.fields.find(field => field.key === e)
        return {
          key: e,
          name: fieldinfo.label,
          after: this.tmpSearch.date[e].after,
          before: this.tmpSearch.date[e].before
        }
      })
    },
    selectList: function () {
      const tmplist = this.fields.filter(field => field.selectSearch)
      const list = {}
      tmplist.map(field => {
        list[field.key] = { list: field.selectSearch, name: field.label }
      })
      return list
    }
  },
  data: function () {
    return {
      tmpSearch: this.search
    }
  },
  methods: {
    changeSearchDate(key) {
      if (this.isDateValid(key)) {
        this.changeSearch()
      }
    },
    changeSearch () {
      this.$emit('updateSearch', this.tmpSearch)
    },
    buttonVariant: function (key) {
      return dateButtonVariant(this.isDateValid(key))
    },
    isMultiple: function (key) {
      const data = this.fields.find(field => {
        return field.key === key
      })
      if (data && data.multiple) {
        return true
      }
      return false
    },
    isDateValid: function (key) {
      return isDatespanValid(
        this.tmpSearch.date[key].after,
        this.tmpSearch.date[key].before
      )
    },
    spanDate: function (date) {
      if (!date) {
        return '指定なし'
      }
      return getArrangedDate(new Date(date))
    },
    resetSearch: function () {
      var search = {
        text: '',
        date: {},
        select: {},
        boolean: {}
      }
      if (Object.keys(this.search.date).length) {
        Object.keys(this.search.date).map(e => {
          search.date[e] = { after: null, before: null }
        })
      }
      if (Object.keys(this.search.select).length) {
        Object.keys(this.search.select).map(e => {
          if (typeof this.search.select[e] === 'object') {
            search.select[e] = []
          } else {
            search.select[e] = 'all'
          }
        })
      }
      this.tmpSearch = search
      this.$emit('updateSearch', search)
    }
  }
}
</script>
